exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".is-yellow{color:#fcdb01}.is-blue{color:#47c0e7}.is-red{color:#9f232b}.active{color:#f6f8f7}.background-light{background-color:#f6f8f7}ul.on-resume li{font-size:.875rem}ul.on-resume li a{color:#52545b}ul.on-resume li a:hover{color:#47c0e7}ul.on-resume li a.active{color:#f6f8f7;text-decoration:none}:focus{outline:1px auto gray;outline-offset:.6rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-710ad9c2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/HeaderLight.vue
// module id = 373
// module chunks = 0